import React, { useState, useEffect } from "react";
import TimeExtensionRequest from "../modals/TimeExtensionRequest";
import BlockWebsiteCategory from "../modals/BlockWebsiteCategory";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import useNotification from "./useNotification";
import NotificationFilterV1 from "../modals/NotificationFilterV1";
import useLangTranslation from "../../../customHooks/languageProvider";
import moment from "moment";
import AlertType from "./AlertType";
import Select from "react-select";
import { kidDevices, setKidDevicesList, setSelectedKidId } from "../../AxiosRtk/DashBoard";
import KidImage from "../../../shared/KidImage/KidImage";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";

const NotificationsV1 = () => {
  const {
    notificationList,
    getNotificationApi,
    loader,
    setLoader,
    notificationFilterShowModal,
    setNotificationFilterShowModal,
  } = useNotification();

  const dispatch = useDispatch();
  const { handleDeviceSelection } = useDashboardDataProvider();
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectChildId, setSelectChildId] = useState(0);
  const [isDisabled, setIsDisabled] = useState(true);

  const [selectedKidData, setSelectedKidData] = useState(null);
  const [showBlockWebsiteModal, setShowBlockWebsiteModal] = useState(false);
  const history = useHistory();
  const { kidList, selectedKidId, kidDevicesList, selectedDeviceData } = useSelector(
    ({ dashboard }) => dashboard
  );

  const [fromDate, setFromDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateError, setDateError] = useState("");
  const { getLangTranslation } = useLangTranslation();

  const [allCategoryData, setAllCategoryData] = useState([
    {
      ID: 2,
      name: "Geolocation",
      isChecked: false,
    },
    {
      ID: 3,
      name: "Screenshots",
      isChecked: false,
    },
    {
      ID: 4,
      name: "Keystrokes",
      isChecked: false,
    },
    {
      ID: 5,
      name: "Nudity",
      isChecked: false,
    },
    {
      ID: 6,
      name: "Videos",
      isChecked: false,
    },
    {
      ID: 7,
      name: "Calls & SMS",
      isChecked: false,
    },
    {
      ID: 8,
      name: "Apps",
      isChecked: false,
    },
    {
      ID: 9,
      name: "Threat",
      isChecked: false,
    },
    {
      ID: 10,
      name: "Social media",
      isChecked: false,
    },
    {
      ID: 11,
      name: "Child Device Status",
      isChecked: false
    },
    {
      ID: 12,
      name: "Task",
      isChecked: false
    },
  ]);

  // Sync selectChildId with selectedKidId from Redux
  useEffect(() => {
    if (selectedKidId) {
      setSelectChildId(selectedKidId);
    }
  }, [selectedKidId]);

  // Handle child selection change
  const handleChildSelection = (kidId) => {
    if (kidId !== selectChildId) {
      dispatch(setSelectedKidId(kidId));
      setSelectChildId(kidId);
      // dispatch(setSelectedDeviceData(null));
    }
  };

  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const openBlockWebsiteModal = () => {
    setShowBlockWebsiteModal(true);
  };
  const closeBlockWebsiteModal = () => {
    setShowBlockWebsiteModal(false);
  };

  const getAllDevices = (kidId) => {
    kidDevices(kidId)
      .then((res) => {
        dispatch(setKidDevicesList(res?.data?.result));
      })
      .catch((error) => {
        console.log("get child devices catch error ===>>>", error?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (selectChildId) {
      const kid = kidList?.find((item) => item?.ID === selectChildId);
      setSelectedKidData(kid);
      getAllDevices(selectChildId);
    }
  }, [selectChildId]);

  const [kidListOptions, setkidListOptions] = useState([]);
  useEffect(() => {
    setkidListOptions(
      kidList?.map((item) => {
        return { value: item?.ID, label: item?.childName };
      })
    );
  }, [kidList]);

  // Ensure that when a device is already selected, notifications are fetched
  useEffect(() => {
    if (selectedDeviceData?.ID) {
      fetchNotifications();
    }
  }, [selectedDeviceData]);

  // Function to fetch notifications based on selected device and date range
  const fetchNotifications = () => {
    // Construct the payload dynamically
    const payload = {
      pageNo: 1,
      itemsPerPage: 200000,
      kidId: selectChildId,
    };
  
    // Only add deviceId if it is selected (not null or 0)
    if (selectedDeviceData?.ID) {
      payload.deviceId = selectedDeviceData?.ID;
    }
  
    // Only add fromDate and toDate if they are selected (non-null and valid)
    if (fromDate && endDate) {
      payload.fromDate = fromDate;
      payload.toDate = endDate;
    }
  
    // Only add notificationType if there are selected categories (non-empty array)
    const notificationIds = allCategoryData
      ?.filter((item) => item?.isChecked)
      ?.map((item) => item?.ID);
  
    if (notificationIds && notificationIds.length > 0) {
      payload.notificationType = notificationIds;
    }
  
    // Call the API with the constructed payload
    getNotificationApi(payload);
  };

  useEffect(() => {
    fetchNotifications();
  }, [selectChildId, selectedDeviceData, fromDate, endDate]);

  function handleFilterSaveBtn() {
    const notificationIds = [];
    allCategoryData
      ?.filter((item) => item?.isChecked)
      ?.forEach((item) => notificationIds.push(item?.ID));
    const payload = {
      pageNo: 1,
      itemsPerPage: 200000,
      deviceId: selectedDeviceData?.ID || 0,
      fromDate,
      toDate: endDate,
      notificationType: notificationIds,
    };
    getNotificationApi(payload);
  }

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  const isDevicesAvailable = kidList && selectedKidId
    ? kidList.find(kid => kid?.ID === selectedKidId)?.KidsDevices?.[0]?.Name
    : null;

  useEffect(() => {
    // Disable the button if no device is available
    if (!isDevicesAvailable) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [isDevicesAvailable]);

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="d-flex align-items-center flex-wrap gap-6">
            <h3
              className="text-blue-900 mb-0 c-pointer"
              onClick={() => history.goBack()}
            >
              {lang?.isRTL === 1 ? (
                <>
                  Notifications <i className="icon-arrow-right" />
                </>
              ) : (
                <>
                  <i className="icon-arrow-left" /> Notifications
                </>
              )}
            </h3>
            <div className="d-flex align-items-center justify-content-end gap-3 flex-fill">
              <div className="list-item content-300 w-100">
                <div className="select-with-icon">
                  <KidImage
                    imageUrl={selectedKidData?.image}
                    gender={selectedKidData?.gender}
                  />
                  <Select
                    className="custom-select"
                    classNamePrefix="custom-select"
                    placeholder="Select Kid"
                    onChange={(val) => handleChildSelection(val.value)}
                    options={kidListOptions}
                    value={
                      kidListOptions?.find((item) => item?.value == selectChildId) ||
                      ""
                    }
                  />
                </div>
              </div>

              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select custom-select-top"
                  classNamePrefix="custom-select"
                  placeholder={getLangTranslation(
                    "PARENT_NOTIFICATION_FILTER_SELECT_DEVICE",
                    "Select Device"
                  )}
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => parseInt(item?.value) === selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />

                {kidDevicesList?.length > 0 && selectedDeviceData?.LockDuration > 0 && (
                  <span className="text-small text-danger select-custom-text">
                    {getLangTranslation(
                      "CHILD_LOCATION_OFFLINE_DEVICE",
                      "Offline Device"
                    )}
                  </span>
                )}
                {kidDevicesList?.length > 0 && !selectedDeviceData?.LockDuration && (
                  <span className="text-small text-success select-custom-text">
                    {getLangTranslation(
                      "CHILD_LOCATION_ACTIVE_DEVICE",
                      "Active device"
                    )}
                  </span>
                )}
              </div>
            </div>
          </div>
          <hr className="my-6" />
          <div className="d-flex align-items-center gap-6 flex-wrap mb-3">
            <div className="d-flex align-items-center content-200 w-100 gap-2">
              <label className="form-label mb-0">From</label>
              <input
                type="date"
                className="form-control"
                name="fromDate"
                onChange={(e) => setFromDate(e.target.value)}
                value={fromDate}
                max={moment(new Date()).format("YYYY-MM-DD")}
              />
            </div>
            <div className="d-flex align-items-center content-200 w-100 gap-2">
              <label className="form-label mb-0">To</label>
              <input
                type="date"
                className="form-control"
                name="endDate"
                onChange={(e) => setEndDate(e.target.value)}
                value={endDate}
                max={moment(new Date()).format("YYYY-MM-DD")}
              />
            </div>
            <span
              className={`icon-wrap pt-cursor c-pointer ${lang?.isRTL === 1 ? "me-auto" : "ms-auto"
                }`}
              onClick={() => setNotificationFilterShowModal(true)}
            >
              <i className="icon-filter" />
            </span>
          </div>
          {dateError && <div className="text-danger mb-3">{dateError}</div>}

          <div className="grid gap-6">
            {isDevicesAvailable && selectedDeviceData?.ID && notificationList?.length > 0 ? (
              notificationList?.map((item) => (
                <AlertType
                  key={item?.notification_id}
                  item={item}
                  getLangTranslation={getLangTranslation}
                  moment={moment}
                />
              ))
            ) : (
              <div
                className="text-center my-3"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginLeft: "42rem",
                  whiteSpace: "nowrap"
                }}
              >
                -- Notification data not found --
              </div>
            )}
          </div>
        </div>
      </div>
      <TimeExtensionRequest showModal={showModal} closeModal={closeModal} />
      <BlockWebsiteCategory
        showModal={showBlockWebsiteModal}
        closeModal={closeBlockWebsiteModal}
      />
      <NotificationFilterV1
        showModal={notificationFilterShowModal}
        setShowModal={setNotificationFilterShowModal}
        getLangTranslation={getLangTranslation}
        allCategoryData={allCategoryData}
        setAllCategoryData={setAllCategoryData}
        loader={loader}
        setLoader={setLoader}
        useNotification={useNotification}
        handleFilterSaveBtn={handleFilterSaveBtn}
      />
    </>
  );
};

export default NotificationsV1;